/**
 * @file Automatically generated by barrelsby.
 */

export * from './fields.component';
export * from './fields.model';
